// extracted by mini-css-extract-plugin
module.exports = {"header":"idt-photoprintswindowdesktop_header__1q5t5"};